import { decoratorsJson } from "@/components/suggestions/providers/data";

import type { DecoratorTypeValue } from "@/components/suggestions/providers/data/types";
import type { SuggestionProvider, SingleSuggestion } from "@/components/suggestions/types";
import type { DocumentModel } from "@/models/DocumentModel";

const SPANNING_DECORATORS: DecoratorTypeValue[] = [
  "overline",
  "widehat",
  "underline",
  "overbrace",
  "underbrace",
  "widetilde",
  "dot",
  "double-dot",
  "triple-dot",
  "quadruple-dot",
];

const MARKING_DECORATORS: DecoratorTypeValue[] = ["cancel", "bcancel", "xcancel", "boxed"];

const applyExpressionDecorator = (
  doc: DocumentModel,
  decoratorType: DecoratorTypeValue,
  nestedKey: string,
): SingleSuggestion<"group"> => {
  const { direction } = doc.selection;
  const decorator = decoratorsJson[decoratorType];

  return {
    type: "single",
    item: {
      type: "group",
      intlName: decorator.intlName,
      symbol: "()",
      props: {
        omitParentheses: true,
      },
    },
    nestedKey,
    nestedOnly: true,
    popupGroup: "apply",
    priority: 1,
    substitution: {
      cursorPlacement: direction === "backward" ? "child:0:start" : "child:0:end",
      selectedNodes: { moveTo: 0 },
      insertDecorators: [
        {
          name: decoratorType,
        },
      ],
    },
  };
};

export const expressionDecoratorSuggestionsProvider: SuggestionProvider = {
  type: "expressionDecorator",
  search: (_, doc) => {
    const { selectedNodes, isMathOnlySelection } = doc.selection;

    if (!isMathOnlySelection || selectedNodes.length === 0) {
      return [[]];
    }

    const spanning =
      selectedNodes.length > 1
        ? SPANNING_DECORATORS.map((type) =>
            applyExpressionDecorator(doc, type, "spanning-decorator"),
          )
        : [];

    const marking = MARKING_DECORATORS.map((type) =>
      applyExpressionDecorator(doc, type, "marking-decorator"),
    );

    return [[...spanning, ...marking]];
  },
};
